import { createElementVNode as _createElementVNode, openBlock as _openBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex w-full justify-end" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 mr-2",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Koosta aruanne ")
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClinicReportsPDFModal = _resolveComponent("ClinicReportsPDFModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "inline-flex items-center px-4 py-2.5 border border-transparent text-sm font-normal rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition duration-500 ease-in-out",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isPDFModal = true))
    }, _hoisted_4),
    (_ctx.isPDFModal)
      ? (_openBlock(), _createBlock(_component_ClinicReportsPDFModal, {
          key: 0,
          "pdf-data": _ctx.pdfData,
          onOnClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isPDFModal = false))
        }, null, 8, ["pdf-data"]))
      : _createCommentVNode("", true)
  ]))
}